@if(link) {
	<a
		class="text-peps-dark-700 bg-peps-gold py-4 px-8 cursor-pointer hover:bg-peps-yellow transition-colors duration-300 uppercase"
		[routerLink]="link"
	>{{ text }}</a>
} @else {
	<a
		class="text-peps-dark-700 bg-peps-gold py-4 px-8 cursor-pointer hover:bg-peps-yellow transition-colors duration-300 uppercase"
		[href]="hrefLink"
		target="_blank"
	>{{ text }}</a>
}
